<nb-card class="card-box">
    <nb-card-header class="content-header">
        <span class="title">{{'common.find-device' | translate}}</span>
        <nb-icon class="close" icon="close-outline" (click)="cancel()"></nb-icon>
    </nb-card-header>
    <nb-card-body class="content-body">
        <app-unavailable-feature [image]="'assets/modals/findDevice.jpg'"
                                 attention="{{ 'packets.function-is-not-included-in-your-plan' | translate }} {{'packets.standard' | translate }}."
                                 descriptionTitle="{{ 'common.find-device' | translate }}"
                                 descriptionContent="{{ 'device.find-device-description' | translate }}"
                                 (cancelCallback)='cancel()'>
        </app-unavailable-feature>
    </nb-card-body>
</nb-card>